import React from "react";
import { NorreButton } from "components/common/NorreButton";
import { ButtonProps } from "@mui/material/Button/Button";

interface Props {
    loading?: boolean;
    to?: string;
}

export const NorreButtonSecondary = ({
    loading = false,
    to,
    color,
    children,
    ...other
}: Props & ButtonProps) => (
    <NorreButton
        loading={loading}
        to={to}
        color={color || "secondary"}
        {...other}
    >
        {children}
    </NorreButton>
);
